import React from 'react';
import { SideSheet, SideSheetProps } from 'evergreen-ui';
import { useWindowSize } from 'react-use';

const MuruSideSheet = ({ children, ...props }: SideSheetProps) => {
  const { height } = useWindowSize();

  return (
    <SideSheet
      {...props}
      shouldCloseOnEscapePress={false}
      shouldCloseOnOverlayClick={false}
      containerProps={{
        display: 'flex',
        flex: '1',
        flexDirection: 'column',
        height,
      }}
    >
      {children}
    </SideSheet>
  );
};

export default MuruSideSheet;
